import React, { Component } from "react";
import { CommonComponent } from "../../operations/Customers";

export default class CustomersListing extends Component {
  render() {
    let { props } = this;
    return <CommonComponent page="customer-support" {...props} />;
  }
}
